import { render } from "./ActionDisplay.vue?vue&type=template&id=65c7486b&scoped=true"
import script from "./ActionDisplay.vue?vue&type=script&lang=js"
export * from "./ActionDisplay.vue?vue&type=script&lang=js"

import "./ActionDisplay.vue?vue&type=style&index=0&id=65c7486b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c7486b"]])

export default __exports__